import React from 'react';
import { Badge } from '@/components/ui/badge';

export const NeuralGridMock: React.FC = () => {
  return (
    <div className="my-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Quote activity map</p>
      <div className="mt-4 grid grid-cols-8 gap-2">
        {Array.from({ length: 40 }).map((_, i) => (
          <div
            key={i}
            className={`h-5 rounded ${i % 5 === 0 ? 'bg-emerald-300' : i % 3 === 0 ? 'bg-indigo-200' : 'bg-slate-200'}`}
          />
        ))}
      </div>
    </div>
  );
};

export const PlayerUiMock: React.FC = () => {
  return (
    <div className="my-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Seller Studio</p>
      <p className="mt-2 text-3xl font-extrabold text-slate-900">$4,500 quote</p>
      <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700">Buyer opened link 2 minutes ago</div>
    </div>
  );
};

export const BrainwaveTableMock: React.FC = () => {
  const rows = [
    { step: 'Create quote', speed: '10-15 sec', outcome: 'Link ready' },
    { step: 'Share checkout', speed: '1 tap', outcome: 'Buyer in flow' },
    { step: 'Buyer decision', speed: '2-5 min', outcome: 'Monthly options visible' },
    { step: 'Follow-up signal', speed: 'Real-time', outcome: 'Rep prompted' },
  ];

  return (
    <div className="my-10 overflow-hidden rounded-2xl border border-slate-200 bg-white">
      <div className="grid grid-cols-3 bg-slate-50 p-4 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
        <div>Step</div>
        <div>Speed</div>
        <div>Outcome</div>
      </div>
      {rows.map((row) => (
        <div key={row.step} className="grid grid-cols-3 border-t border-slate-200 p-4 text-sm text-slate-700">
          <div className="font-semibold text-slate-900">{row.step}</div>
          <div>{row.speed}</div>
          <div>{row.outcome}</div>
        </div>
      ))}
    </div>
  );
};

export const HabitGridMock: React.FC = () => {
  const days = Array.from({ length: 56 }).map((_, i) => i % 4 !== 0);
  return (
    <div className="my-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex items-center justify-between">
        <p className="text-lg font-bold text-slate-900">Follow-up consistency</p>
        <Badge variant="secondary">8 weeks</Badge>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        {days.map((active, i) => (
          <div key={i} className={`h-4 w-4 rounded-sm ${active ? 'bg-emerald-500' : 'bg-slate-200'}`} />
        ))}
      </div>
    </div>
  );
};
